/* Publish by EComposer at 2026-06-13 11:12:42*/
;try{
 
const QUESTIONS = [
  {
    id: 1,
    emoji: '💸',
    label: 'Budget',
    question: 'Ton budget pour ce cadeau ?',
    cols: 2,
    options: [
      {
        label: 'Moins de 20€',
        emoji: '🌱',
        desc: 'Un joli cadeau accessible et plein de charme',
        budgetKey: 'UNDER_20',
        scores: { SPA: 3, BOUGIE: 2, PARFUM: 2, BRACELET: 2, ENCENS: 2, DECO: 1 }
      },
      {
        label: '20€ à 40€',
        emoji: '🌸',
        desc: 'Le bon équilibre entre effet waouh et budget',
        budgetKey: 'BETWEEN_20_40',
        scores: { COFFRET: 3, SPA: 2, BRACELET: 2, ENCENS: 1, DECO: 2, FLEURS: 2 }
      },
      {
        label: '40€ à 60€',
        emoji: '✨',
        desc: 'Un cadeau généreux qui marque les esprits',
        budgetKey: 'BETWEEN_40_60',
        scores: { COFFRET: 4, BOUGIE: 2, SPIRITUEL: 2, FLEURS: 2, BIJOU: 2, DECO: 1 }
      },
      {
        label: '60€ et plus',
        emoji: '💎',
        desc: 'Le grand cadeau qui fait vraiment sensation',
        budgetKey: 'OVER_60',
        scores: { COFFRET: 4, SPIRITUEL: 3, BIJOU: 2, DECO: 2, BIEN_ETRE: 2 }
      }
    ]
  },
  {
    id: 2,
    emoji: '👩',
    label: 'Profil',
    question: 'Comment tu décrirais ton amie ?',
    cols: 2,
    options: [
      {
        label: 'Girly & glamour',
        emoji: '💅',
        desc: 'Elle aime les jolies choses, les détails doux et raffinés',
        scores: { FLEURS: 3, BOUGIE: 2, PARFUM: 2, BRACELET: 2, COFFRET: 1 }
      },
      {
        label: 'Boho & nature',
        emoji: '🌿',
        desc: 'Elle aime l’authentique, le naturel, le sensoriel',
        scores: { ENCENS: 3, SPA: 3, BRACELET: 2, BIEN_ETRE: 2, DECO: 1 }
      },
      {
        label: 'Zen & spirituelle',
        emoji: '🧘',
        desc: 'Rituels, énergies, méditation, ambiance apaisante',
        scores: { ENCENS: 3, SPIRITUEL: 3, BOUGIE: 2, PARFUM: 2, BIJOU: 2 }
      },
      {
        label: 'Dynamique & curieuse',
        emoji: '⚡',
        desc: 'Elle aime découvrir, tester, recevoir un vrai cadeau marquant',
        scores: { COFFRET: 3, BIEN_ETRE: 2, DECO: 2, FLEURS: 1, SPA: 1 }
      }
    ]
  },
  {
    id: 3,
    emoji: '🎁',
    label: 'Envie',
    question: 'Elle apprécierait surtout…',
    cols: 3,
    options: [
      {
        label: 'Un rituel cocooning',
        emoji: '🛁',
        desc: 'Un moment pour elle, tout en douceur',
        scores: { SPA: 4, COFFRET: 2, BIEN_ETRE: 2 }
      },
      {
        label: 'Un objet symbolique',
        emoji: '📿',
        desc: 'Quelque chose qui a du sens ou une énergie particulière',
        scores: { BRACELET: 4, BIJOU: 3, SPIRITUEL: 2 }
      },
      {
        label: 'Une belle ambiance',
        emoji: '🕯️',
        desc: 'Parfum, lumière, déco, atmosphère réconfortante',
        scores: { BOUGIE: 4, PARFUM: 3, ENCENS: 2, DECO: 2 }
      }
    ]
  },
  {
    id: 4,
    emoji: '🎉',
    label: 'Occasion',
    question: 'C’est pour quelle occasion ?',
    cols: 2,
    options: [
      {
        label: 'Son anniversaire',
        emoji: '🎂',
        desc: 'Un vrai cadeau marquant',
        scores: { COFFRET: 3, FLEURS: 2, BIJOU: 2, SPIRITUEL: 1 }
      },
      {
        label: 'Juste pour lui faire plaisir',
        emoji: '💌',
        desc: 'Une attention délicate et spontanée',
        scores: { BOUGIE: 2, SPA: 2, PARFUM: 2, BRACELET: 1 }
      },
      {
        label: 'Une occasion spéciale',
        emoji: '🥂',
        desc: 'Il faut un cadeau qui se distingue',
        scores: { COFFRET: 3, BIJOU: 2, SPIRITUEL: 2, FLEURS: 1 }
      },
      {
        label: 'Un geste apaisant',
        emoji: '🤍',
        desc: 'Douceur, réconfort, sérénité',
        scores: { SPA: 2, BOUGIE: 2, ENCENS: 2, PARFUM: 1 }
      }
    ]
  },
  {
    id: 5,
    emoji: '💖',
    label: 'Valeur',
    question: 'Ce qui compte le plus pour toi dans ce cadeau ?',
    cols: 2,
    options: [
      {
        label: 'L’effet surprise',
        emoji: '🎊',
        desc: 'Qu’elle ouvre un vrai cadeau coup de cœur',
        scores: { COFFRET: 3, FLEURS: 2, SPIRITUEL: 2, BIEN_ETRE: 1 }
      },
      {
        label: 'Le naturel & sensoriel',
        emoji: '🌱',
        desc: 'Des matières, senteurs et rituels doux',
        scores: { SPA: 3, ENCENS: 3, BOUGIE: 2, PARFUM: 2 }
      },
      {
        label: 'L’élégance & l’esthétique',
        emoji: '✨',
        desc: 'Un beau cadeau à offrir et à exposer',
        scores: { FLEURS: 3, BOUGIE: 2, BRACELET: 2, DECO: 2, BIJOU: 1 }
      },
      {
        label: 'Le rapport plaisir / budget',
        emoji: '💚',
        desc: 'Un cadeau canon dans la bonne fourchette',
        scores: { SPA: 2, BOUGIE: 2, PARFUM: 2, BRACELET: 2, ENCENS: 1 }
      }
    ]
  }
];

const BUDGET_RANGES = {
  UNDER_20: { min: 0, max: 20 },
  BETWEEN_20_40: { min: 20, max: 40 },
  BETWEEN_40_60: { min: 40, max: 60 },
  OVER_60: { min: 60, max: Infinity }
};

const CATEGORY_META = {
  SPA:        { emoji: '🛁', tag: 'Cocooning' },
  BOUGIE:     { emoji: '🕯️', tag: 'Ambiance' },
  PARFUM:     { emoji: '🌸', tag: 'Sensoriel' },
  BRACELET:   { emoji: '📿', tag: 'Symbolique' },
  ENCENS:     { emoji: '🪔', tag: 'Zen' },
  DECO:       { emoji: '🏡', tag: 'Déco' },
  COFFRET:    { emoji: '🎁', tag: 'Cadeau complet' },
  FLEURS:     { emoji: '🌹', tag: 'Très visuel' },
  SPIRITUEL:  { emoji: '🔮', tag: 'Spirituel' },
  BIJOU:      { emoji: '💎', tag: 'Bijou / mala' },
  BIEN_ETRE:  { emoji: '💆', tag: 'Bien-être' }
};

const REFERENCE_PRODUCTS = [
  // < 20 €
  {
    id: 'sel-bain-aromatherapie-relaxant',
    name: 'Sel de Bain Aromathérapie Relaxant',
    price: 9.90,
    priceLabel: '9,90€',
    url: 'https://www.astroya.fr/products/sel-bain-aromatherapie-relaxant',
    image: 'https://www.astroya.fr/cdn/shop/files/sels_bain_aromatherapie_lavande_et_orange_df2a38dc-6201-4ea4-a018-99b4297c8eba.webp?v=1758873457&width=1780',
    category: 'SPA'
  },
  {
    id: 'bougie-parfumee-goloka-70g',
    name: 'Bougie Parfumée Goloka 70g',
    price: 7.90,
    priceLabel: '7,90€',
    url: 'https://www.astroya.fr/products/bougie-parfumee-goloka-70g?variant=48197423792473',
    image: 'https://www.astroya.fr/cdn/shop/files/bougie_goloka_romarin.webp?v=1755849956&width=1780',
    category: 'BOUGIE'
  },
  {
    id: 'parfum-interieur-spray-orange-organic-goodness',
    name: "Parfum d’Intérieur Spray Orange",
    price: 7.90,
    priceLabel: '7,90€',
    url: 'https://www.astroya.fr/products/parfum-interieur-spray-orange-organic-goodness',
    image: 'https://www.astroya.fr/cdn/shop/files/spray_organic_goodness_orange_75b8c185-32c6-4f0c-997d-1218511c4ec0.webp?v=1756115497&width=1780',
    category: 'PARFUM'
  },
  {
    id: 'bruleur-encens-en-gres',
    name: 'Brûleur Encens en Grès',
    price: 9.50,
    priceLabel: '9,50€',
    url: 'https://www.astroya.fr/products/bruleur-encens-en-gres',
    image: 'https://www.astroya.fr/cdn/shop/files/brule_encens_carre_en_gres.webp?v=1758174743&width=1780',
    category: 'ENCENS'
  },
  {
    id: 'bracelet-de-quartz-rose',
    name: 'Bracelet de Quartz Rose',
    price: 8.90,
    priceLabel: '8,90€',
    url: 'https://www.astroya.fr/products/bracelet-de-quartz-rose',
    image: 'https://www.astroya.fr/cdn/shop/files/Bracelet_Calme_Paix_et_Tendresse_avec_Pierres_Naturelles_en_Quartz_Rose_1.webp?v=1770043400&width=1780',
    category: 'BRACELET'
  },
  {
    id: 'pochette-velours-beige-fleur-de-vie',
    name: 'Pochette Velours Beige Fleur de Vie',
    price: 19.90,
    priceLabel: '19,90€',
    url: 'https://www.astroya.fr/products/pochette-velours-beige-fleur-de-vie',
    image: 'https://www.astroya.fr/cdn/shop/files/pochette_velours_beige_broderie_fleurs_de_vie.webp?v=1756744577&width=1780',
    category: 'DECO'
  },
  {
    id: 'fleurs-de-savon-coeur-de-24-roses',
    name: 'Fleurs de Savon Cœur de 24 Roses',
    price: 15.90,
    priceLabel: '15,90€',
    url: 'https://www.astroya.fr/products/fleurs-de-savon-coeur-de-24-roses?variant=47777706213721',
    image: 'https://www.astroya.fr/cdn/shop/files/1311_883f32a6-eb57-4f26-bfb7-cc49f75b8416.jpg?v=1756666507&width=1780',
    category: 'FLEURS'
  },
  {
    id: 'chantilly-douche-pamplemousse-160g',
    name: 'Chantilly Douche Pamplemousse',
    price: 17.90,
    priceLabel: '17,90€',
    url: 'https://www.astroya.fr/products/chantilly-douche-pamplemousse-160g',
    image: 'https://www.astroya.fr/cdn/shop/files/chantilly_douche_pamplemousse.webp?v=1753352869&width=1780',
    category: 'BIEN_ETRE'
  },

  // 20 - 40 €
  {
    id: 'panier-de-fleurs-de-savon',
    name: 'Panier de Fleurs de Savon',
    price: 25.90,
    priceLabel: '25,90€',
    url: 'https://www.astroya.fr/products/panier-de-fleurs-de-savon',
    image: 'https://www.astroya.fr/cdn/shop/files/IMG_1138.webp?v=1756666031&width=1780',
    category: 'FLEURS'
  },
  {
    id: 'bracelet-amazonite-a-facettes-8mm',
    name: 'Bracelet Amazonite à Facettes 8 mm',
    price: 35.90,
    priceLabel: '35,90€',
    url: 'https://www.astroya.fr/products/bracelet-amazonite-a-facettes-8mm',
    image: 'https://www.astroya.fr/cdn/shop/files/IMG_9456.webp?v=1756379550&width=1780',
    category: 'BRACELET'
  },
  {
    id: 'ensemble-encens-fleur-de-vie',
    name: 'Ensemble Encens Fleur de Vie',
    price: 29.10,
    priceLabel: '29,10€',
    url: 'https://www.astroya.fr/products/ensemble-encens-fleur-de-vie-coffret-purification-energie-sacree',
    image: 'https://www.astroya.fr/cdn/shop/files/ensemble_encens_fleur_de_vie.webp?v=1768486338&width=1780',
    category: 'ENCENS'
  },
  {
    id: 'coffret-cadeau-bougie-bombes-de-bain-the-roses-provence',
    name: 'Coffret Bougie & Bombes de Bain The Roses Provence',
    price: 39.90,
    priceLabel: '39,90€',
    url: 'https://www.astroya.fr/products/coffret-cadeau-bougie-bombes-de-bain-the-roses-provence',
    image: 'https://www.astroya.fr/cdn/shop/files/coffret_cadeau_bougie_bombes_de_bain_violet.webp?v=1754919950&width=1780',
    category: 'COFFRET'
  },
  {
    id: 'coffret-cadeau-spa-detente-totale',
    name: 'Coffret Cadeau Spa Détente Totale',
    price: 38.90,
    priceLabel: '38,90€',
    url: 'https://www.astroya.fr/products/coffret-cadeau-spa-detente-totale',
    image: 'https://www.astroya.fr/cdn/shop/files/hope_hare_salle_de_bain_1.webp?v=1763793353&width=1780',
    category: 'SPA'
  },
  {
    id: 'coffret-cadeaux-bougie-bracelet-verseau',
    name: 'Coffret Cadeaux Bougie Bracelet Verseau',
    price: 26.90,
    priceLabel: '26,90€',
    url: 'https://www.astroya.fr/products/coffret-cadeaux-bougie-bracelet-verseau',
    image: 'https://www.astroya.fr/cdn/shop/files/257699.jpg?v=1754742192&width=1780',
    category: 'COFFRET'
  },
  {
    id: 'coffret-cadeau-spa-orange-detox',
    name: 'Coffret Cadeau Spa Orange Détox',
    price: 38.90,
    priceLabel: '38,90€',
    url: 'https://www.astroya.fr/products/coffret-cadeau-spa-orange-detox',
    image: 'https://www.astroya.fr/cdn/shop/files/coffret_spa_rose.webp?v=1763793746&width=1780',
    category: 'SPA'
  },
  {
    id: 'fleurs-de-savon-boite-ronde',
    name: 'Fleurs de Savon Boîte Ronde',
    price: 33.90,
    priceLabel: '33,90€',
    url: 'https://www.astroya.fr/products/fleurs-de-savon-boite-ronde?variant=48621588414809',
    image: 'https://www.astroya.fr/cdn/shop/files/66281.jpg?v=1756666230&width=1780',
    category: 'FLEURS'
  },

  // 40 - 60 €
  {
    id: '3-bougies-botaniques-chevrefeuille-citron',
    name: '3 Bougies Botaniques Chèvrefeuille Citron',
    price: 49.90,
    priceLabel: '49,90€',
    url: 'https://www.astroya.fr/products/3-bougies-botaniques-chevrefeuille-citron',
    image: 'https://www.astroya.fr/cdn/shop/files/bougies_botaniques_chevrefeuille_citronne.webp?v=1763198251&width=1780',
    category: 'BOUGIE'
  },
  {
    id: 'bouquet-de-fleurs-de-savon-xl',
    name: 'Bouquet de Fleurs de Savon XL',
    price: 42.90,
    priceLabel: '42,90€',
    url: 'https://www.astroya.fr/products/bouquet-de-fleurs-de-savon-xl-30x20x12?variant=47777732755801',
    image: 'https://www.astroya.fr/cdn/shop/files/2997_f058a4eb-72d0-4cce-a436-6500339d5162.jpg?v=1756666361&width=1780',
    category: 'FLEURS'
  },
  {
    id: 'cadeau-bien-etre-aromatherapie',
    name: 'Cadeau Bien-être Aromathérapie',
    price: 44.90,
    priceLabel: '44,90€',
    url: 'https://www.astroya.fr/products/cadeau-bien-etre-aromatherapie-bombes-bain-bougie-savon-massage',
    image: 'https://www.astroya.fr/cdn/shop/files/coffret_4_bombes_de_bain_aromatherapie.webp?v=1768480617&width=1780',
    category: 'COFFRET'
  },
  {
    id: 'cadeau-bien-etre-7-chakras',
    name: 'Cadeau Bien-être 7 Chakras',
    price: 58.70,
    priceLabel: '58,70€',
    url: 'https://www.astroya.fr/products/cadeau-bien-etre-7-chakras',
    image: 'https://www.astroya.fr/cdn/shop/files/coffret_7_chakras_bombes_de_bain_bracelet_bougie.webp?v=1768481162&width=1780',
    category: 'SPIRITUEL'
  },
  {
    id: 'coffret-carre-fleurs-savon-roses',
    name: 'Coffret Carré Fleurs de Savon Roses',
    price: 40.90,
    priceLabel: '40,90€',
    url: 'https://www.astroya.fr/products/coffret-carre-fleurs-savon-roses-roses',
    image: 'https://www.astroya.fr/cdn/shop/files/coffret_fleurs_de_savon_roses.webp?v=1756665731&width=1780',
    category: 'FLEURS'
  },
  {
    id: 'coffret-tarot-marseille-boite-pentacle',
    name: 'Coffret Tarot Marseille Boîte Pentacle',
    price: 57.90,
    priceLabel: '57,90€',
    url: 'https://www.astroya.fr/products/coffret-tarot-marseille-boite-pentacle',
    image: 'https://www.astroya.fr/cdn/shop/files/coffret_boite_tarot_de_marseille.webp?v=1768557955&width=1780',
    category: 'SPIRITUEL'
  },
  {
    id: 'mala-pierre-de-lune-blanc-108-perles',
    name: 'Mala Pierre de Lune Blanc 108 Perles',
    price: 54.90,
    priceLabel: '54,90€',
    url: 'https://www.astroya.fr/products/mala-pierre-de-lune-blanc-108-perles',
    image: 'https://www.astroya.fr/cdn/shop/files/collier_mala_pierre_de_lune.webp?v=1757065249&width=1780',
    category: 'BIJOU'
  },
  {
    id: 'tresors-du-monde-agadir',
    name: 'Cadeau Bien-être Trésors du Monde Agadir',
    price: 56.90,
    priceLabel: '56,90€',
    url: 'https://www.astroya.fr/products/cadeau-bien-etre-tresors-du-monde-agadir',
    image: 'https://www.astroya.fr/cdn/shop/files/coffret_cadeau_bien_etre_agadir_2_c06d16cd-4df2-4a92-8e0d-0887d14f58ee.webp?v=1769266522&width=1780',
    category: 'COFFRET'
  },

  // 60 € et +
  {
    id: 'tresors-du-monde-bahia',
    name: 'Cadeau Bien-être Trésors du Monde Bahia',
    price: 69.90,
    priceLabel: '69,90€',
    url: 'https://www.astroya.fr/products/cadeau-bien-etre-tresors-du-monde-bahia',
    image: 'https://www.astroya.fr/cdn/shop/files/cadeau_bien_etre_bahia_decor_plage.webp?v=1770883262&width=1780',
    category: 'COFFRET'
  },
  {
    id: 'coffret-cadeau-femme-tresors-du-japon',
    name: 'Coffret Cadeau Femme Trésors du Japon',
    price: 68.90,
    priceLabel: '68,90€',
    url: 'https://www.astroya.fr/products/coffret-cadeau-femme-tresors-du-japon',
    image: 'https://www.astroya.fr/cdn/shop/files/coffret_cadeau_japon_2.webp?v=1758793723&width=1780',
    category: 'COFFRET'
  },
  {
    id: 'mala-fluorite-108-perles',
    name: 'Mala Fluorite 108 Perles',
    price: 64.90,
    priceLabel: '64,90€',
    url: 'https://www.astroya.fr/products/mala-fluorite-108-perles',
    image: 'https://www.astroya.fr/cdn/shop/files/mala_fluorite_108_perles.webp?v=1756886840&width=1780',
    category: 'BIJOU'
  },
  {
    id: 'gourde-vitajuwel-via-prana-violette',
    name: 'Gourde Vitajuwel Via Prana Violette',
    price: 89.90,
    priceLabel: '89,90€',
    url: 'https://www.astroya.fr/products/gourde-vitajuwel-via-prana-violette',
    image: 'https://www.astroya.fr/cdn/shop/files/bouteille_vitajuwell_violette_decor.webp?v=1763481705&width=1780',
    category: 'BIEN_ETRE'
  },
  {
    id: 'cadeau-harmonie-mala-pierre-de-lune',
    name: 'Cadeau Harmonie Mala Pierre de Lune',
    price: 72.90,
    priceLabel: '72,90€',
    url: 'https://www.astroya.fr/products/cadeau-harmonie-mala-pierre-de-lune',
    image: 'https://www.astroya.fr/cdn/shop/files/pochette_cadeau_mala_lune_872f641f-dc00-48a4-9d5c-32a8b6f3fac5.webp?v=1772171298&width=1780',
    category: 'SPIRITUEL'
  },
  {
    id: 'bouddha-thai-au-repos',
    name: 'Bouddha Thaï au Repos',
    price: 89.00,
    priceLabel: '89€',
    url: 'https://www.astroya.fr/products/bouddha-thai-au-repos',
    image: 'https://www.astroya.fr/cdn/shop/files/statuette_bouddha_thai_au_repos.webp?v=1757519589&width=1780',
    category: 'DECO'
  }
];

const CAROUSEL_ITEMS = [
  {
    name: 'Sel de Bain Relaxant',
    price: '9,90€',
    tag: 'Cocooning',
    emoji: '🛁',
    url: 'https://www.astroya.fr/products/sel-bain-aromatherapie-relaxant',
    image: 'https://www.astroya.fr/cdn/shop/files/sels_bain_aromatherapie_lavande_et_orange_df2a38dc-6201-4ea4-a018-99b4297c8eba.webp?v=1758873457&width=1780'
  },
  {
    name: 'Bracelet Quartz Rose',
    price: '8,90€',
    tag: 'Symbolique',
    emoji: '📿',
    url: 'https://www.astroya.fr/products/bracelet-de-quartz-rose',
    image: 'https://www.astroya.fr/cdn/shop/files/Bracelet_Calme_Paix_et_Tendresse_avec_Pierres_Naturelles_en_Quartz_Rose_1.webp?v=1770043400&width=1780'
  },
  {
    name: 'Coffret Spa Détente Totale',
    price: '38,90€',
    tag: 'Best-seller',
    emoji: '🎁',
    url: 'https://www.astroya.fr/products/coffret-cadeau-spa-detente-totale',
    image: 'https://www.astroya.fr/cdn/shop/files/hope_hare_salle_de_bain_1.webp?v=1763793353&width=1780'
  },
  {
    name: 'Bouquet Fleurs de Savon XL',
    price: '42,90€',
    tag: 'Très visuel',
    emoji: '🌹',
    url: 'https://www.astroya.fr/products/bouquet-de-fleurs-de-savon-xl-30x20x12?variant=47777732755801',
    image: 'https://www.astroya.fr/cdn/shop/files/2997_f058a4eb-72d0-4cce-a436-6500339d5162.jpg?v=1756666361&width=1780'
  },
  {
    name: 'Trésors du Monde Bahia',
    price: '69,90€',
    tag: 'Premium',
    emoji: '💎',
    url: 'https://www.astroya.fr/products/cadeau-bien-etre-tresors-du-monde-bahia',
    image: 'https://www.astroya.fr/cdn/shop/files/cadeau_bien_etre_bahia_decor_plage.webp?v=1770883262&width=1780'
  }
];

let currentQ = 0;
let answers = new Array(QUESTIONS.length).fill(null);
let scores = {};
let imageCache = {};

renderQuestion(0);
buildCarousel();

const obs = new IntersectionObserver((entries) => {
  const cta = document.getElementById('stickyCta');
  if (cta) {
    cta.classList.toggle('hidden', entries[0].isIntersecting);
  }
}, { threshold: 0.3 });

const quizBox = document.getElementById('quizBox');
if (quizBox) {
  obs.observe(quizBox);
}

function renderDots(idx) {
  const container = document.getElementById('stepDots');
  if (!container) return;

  container.innerHTML = QUESTIONS.map((_, i) => {
    let className = 'step-dot';
    if (i < idx) className += ' done';
    else if (i === idx) className += ' active';
    return `<div class="${className}"></div>`;
  }).join('');
}

function renderQuestion(idx) {
  const q = QUESTIONS[idx];
  const progressFill = document.getElementById('progressFill');

  if (progressFill) {
    progressFill.style.width = `${Math.round((idx / QUESTIONS.length) * 100)}%`;
  }

  renderDots(idx);

  const optionsHtml = q.options.map((option, optionIndex) => {
    const isSelected = answers[idx] === optionIndex;
    return `
      <button
        class="option-btn${isSelected ? ' selected' : ''}"
        onclick="selectOption(${idx}, ${optionIndex})"
        aria-pressed="${isSelected}"
      >
        <div class="opt-top">
          <span class="opt-emoji">${option.emoji}</span>
          <span class="opt-label">${option.label}</span>
        </div>
        <span class="opt-desc">${option.desc}</span>
      </button>
    `;
  }).join('');

  document.getElementById('quizContent').innerHTML = `
    <div class="step-counter">
      <span>Question ${idx + 1} sur ${QUESTIONS.length}</span>
      <span class="step-emoji">${q.emoji}</span>
    </div>
    <div class="question-wrap">
      <p class="question-text">${q.question}</p>
      <div class="options-grid cols-${q.cols}">
        ${optionsHtml}
      </div>
    </div>
    <div class="quiz-nav">
      <button class="btn-back${idx === 0 ? ' hidden' : ''}" onclick="goBack()">← Retour</button>
      <button
        class="btn-next"
        id="btnNext"
        ${answers[idx] === null ? 'disabled' : ''}
        onclick="goNext()"
      >
        ${idx === QUESTIONS.length - 1 ? 'Voir mes idées cadeaux 💝' : 'Continuer →'}
      </button>
    </div>
  `;
}

function selectOption(questionIndex, optionIndex) {
  answers[questionIndex] = optionIndex;

  document.querySelectorAll('.option-btn').forEach((button, i) => {
    const isSelected = i === optionIndex;
    button.classList.toggle('selected', isSelected);
    button.setAttribute('aria-pressed', String(isSelected));
  });

  const nextButton = document.getElementById('btnNext');
  if (nextButton) {
    nextButton.disabled = false;
  }
}

function goNext() {
  if (answers[currentQ] === null) return;

  if (currentQ < QUESTIONS.length - 1) {
    currentQ += 1;
    renderQuestion(currentQ);
    scrollQuizIntoView();
    return;
  }

  computeScores();
  renderResults();
}

function goBack() {
  if (currentQ <= 0) return;
  currentQ -= 1;
  renderQuestion(currentQ);
  scrollQuizIntoView();
}

function scrollQuizIntoView() {
  const box = document.getElementById('quizBox');
  if (box) {
    box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function createEmptyScores() {
  const allCategories = Object.keys(CATEGORY_META);
  return allCategories.reduce((acc, key) => {
    acc[key] = 0;
    return acc;
  }, {});
}

function getSelectedBudgetKey() {
  const budgetAnswerIndex = answers[0];
  if (budgetAnswerIndex === null) return null;
  return QUESTIONS[0].options[budgetAnswerIndex].budgetKey || null;
}

function computeScores() {
  scores = createEmptyScores();

  QUESTIONS.forEach((question, questionIndex) => {
    const selectedAnswerIndex = answers[questionIndex];
    if (selectedAnswerIndex === null) return;

    const selectedOption = question.options[selectedAnswerIndex];
    if (!selectedOption || !selectedOption.scores) return;

    Object.entries(selectedOption.scores).forEach(([category, value]) => {
      scores[category] = (scores[category] || 0) + value;
    });
  });
}

function isProductInBudget(product, budgetKey) {
  if (!budgetKey) return true;
  const range = BUDGET_RANGES[budgetKey];
  if (!range) return true;
  return product.price >= range.min && product.price < (range.max === Infinity ? Infinity : range.max + 0.0001);
}

function getProductsInBudget(budgetKey) {
  return REFERENCE_PRODUCTS.filter((product) => isProductInBudget(product, budgetKey));
}

function getRankedCategories() {
  return Object.entries(scores)
    .filter(([, value]) => value > 0)
    .sort((a, b) => b[1] - a[1])
    .map(([category]) => category);
}

function getBestProductForCategory(category, budgetKey, excludedIds = new Set()) {
  const candidates = getProductsInBudget(budgetKey)
    .filter((product) => product.category === category && !excludedIds.has(product.id))
    .sort((a, b) => a.price - b.price);

  return candidates[0] || null;
}

function getFallbackProducts(budgetKey, excludedIds = new Set()) {
  const rankedCategories = getRankedCategories();

  return getProductsInBudget(budgetKey)
    .filter((product) => !excludedIds.has(product.id))
    .sort((a, b) => {
      const scoreA = scores[a.category] || 0;
      const scoreB = scores[b.category] || 0;

      if (scoreB !== scoreA) return scoreB - scoreA;

      const rankA = rankedCategories.indexOf(a.category);
      const rankB = rankedCategories.indexOf(b.category);

      if (rankA !== rankB) {
        if (rankA === -1) return 1;
        if (rankB === -1) return -1;
        return rankA - rankB;
      }

      return a.price - b.price;
    });
}

function getTopRecommendations(limit = 3) {
  const budgetKey = getSelectedBudgetKey();
  const rankedCategories = getRankedCategories();
  const selectedProducts = [];
  const usedIds = new Set();

  rankedCategories.forEach((category) => {
    if (selectedProducts.length >= limit) return;

    const bestProduct = getBestProductForCategory(category, budgetKey, usedIds);
    if (bestProduct) {
      selectedProducts.push({
        ...bestProduct,
        matchCategory: category,
        matchScore: scores[category] || 0
      });
      usedIds.add(bestProduct.id);
    }
  });

  if (selectedProducts.length < limit) {
    const fallbackProducts = getFallbackProducts(budgetKey, usedIds);

    fallbackProducts.forEach((product) => {
      if (selectedProducts.length >= limit) return;
      selectedProducts.push({
        ...product,
        matchCategory: product.category,
        matchScore: scores[product.category] || 0
      });
      usedIds.add(product.id);
    });
  }

  return selectedProducts.slice(0, limit);
}

function getCategoryLabel(category) {
  return CATEGORY_META[category]?.tag || 'Coup de cœur';
}

function getCategoryEmoji(category) {
  return CATEGORY_META[category]?.emoji || '🎁';
}

function renderResults() {
  const progressFill = document.getElementById('progressFill');
  if (progressFill) {
    progressFill.style.width = '100%';
  }

  renderDots(QUESTIONS.length);

  const recommendations = getTopRecommendations(3);
  const maxScore = Math.max(...recommendations.map((item) => item.matchScore || 1), 1);

  const rankLabels = ['💜 Notre coup de cœur', '🥈 Idée numéro 2', '🥉 Coup de bonus'];
  const rankClasses = ['rank-1', 'rank-2', 'rank-3'];

  const cardsHtml = recommendations.map((product, index) => {
    const scorePercent = Math.max(18, Math.round(((product.matchScore || 1) / maxScore) * 100));

    return `
      <a
        href="${product.url}"
        target="_blank"
        rel="noopener"
        class="product-card ${rankClasses[index]}"
        id="card-${product.id}"
      >
        <div class="product-img-wrap">
          <div class="product-rank ${rankClasses[index]}">${rankLabels[index]}</div>
          <div class="product-img-placeholder" id="placeholder-${product.id}">
            <span>${getCategoryEmoji(product.category)}</span>
            <span class="ph-label">${getCategoryLabel(product.category)}</span>
          </div>
        </div>

        <div class="product-score-bar">
          <div class="product-score-fill" id="score-${product.id}" style="width:0%"></div>
        </div>

        <div class="product-body">
          <span class="product-tag">${getCategoryLabel(product.category)}</span>
          <h3 class="product-name">${product.name}</h3>
          <p class="product-desc">Sélectionné selon ses goûts et dans la bonne fourchette budget.</p>
          <div class="product-footer">
            <span class="product-price">${product.priceLabel}</span>
            <span class="product-cta">Voir le produit →</span>
          </div>
          <div class="product-budget-note">✅ Compatible avec ton budget</div>
        </div>
      </a>
    `;
  }).join('');

  document.getElementById('quizContent').innerHTML = `
    <div class="results-wrap">
      <div class="results-header">
        <span class="trophy">🎉</span>
        <h2 class="results-title">Voici les idées <em>parfaites</em> pour elle !</h2>
        <p class="results-sub">Sélectionnées à partir de ton budget et de ton fichier de référence 💜</p>
      </div>

      <div class="products-grid">${cardsHtml}</div>

      <div class="result-cta-block">
        <p>
          🎁 <strong>Des idées vraiment dans la bonne tranche</strong> — le quiz filtre maintenant sur le prix réel des produits.<br>
          Tu peux offrir l’esprit léger.
        </p>
        <a
          href="https://www.astroya.fr/collections/idees-cadeaux-nouveautes"
          target="_blank"
          class="btn-shop-all"
        >
          Voir toutes nos idées cadeaux →
        </a>
      </div>

      <button class="btn-restart" onclick="restartQuiz()">🔄 Recommencer le quiz</button>
    </div>
  `;

  recommendations.forEach((product) => {
    const pct = Math.max(18, Math.round(((product.matchScore || 1) / maxScore) * 100));
    setTimeout(() => {
      const el = document.getElementById(`score-${product.id}`);
      if (el) {
        el.style.width = `${pct}%`;
      }
    }, 200);
  });

  recommendations.forEach((product) => {
    applyImage(product.id, product.image, product.name);
  });

  launchConfetti();
  scrollQuizIntoView();
}

function applyImage(productId, src, altText) {
  const placeholder = document.getElementById(`placeholder-${productId}`);
  const wrapper = placeholder?.parentElement;

  if (!wrapper || wrapper.querySelector('img.loaded') || !src) return;

  const img = document.createElement('img');
  img.alt = altText;
  img.loading = 'eager';

  img.onload = () => {
    img.classList.add('loaded');
    wrapper.appendChild(img);
  };

  img.onerror = () => {};
  img.src = src;
}

function buildCarousel() {
  const track = document.getElementById('carouselTrack');
  if (!track) return;

  CAROUSEL_ITEMS.forEach((item, index) => {
    const card = document.createElement('a');
    card.href = item.url;
    card.target = '_blank';
    card.rel = 'noopener';
    card.className = 'carousel-card';
    card.id = `cc-${index}`;

    card.innerHTML = `
      <div class="cc-img" id="cc-img-${index}">
        <div class="cc-img-ph"><span>${item.emoji}</span></div>
      </div>
      <div class="cc-body">
        <div class="cc-name">${item.name}</div>
        <div class="cc-price">${item.price}</div>
        <div class="cc-tag">${item.tag}</div>
      </div>
    `;

    track.appendChild(card);

    if (item.image) {
      applyCarouselImage(index, item.image, item.name);
    }
  });
}

function applyCarouselImage(index, src, altText) {
  const wrapper = document.getElementById(`cc-img-${index}`);
  if (!wrapper || wrapper.querySelector('img.loaded') || !src) return;

  const img = document.createElement('img');
  img.alt = altText;
  img.loading = 'lazy';

  img.onload = () => {
    img.classList.add('loaded');
    wrapper.appendChild(img);
  };

  img.onerror = () => {};
  img.src = src;
}

function scrollCarousel(direction) {
  const track = document.getElementById('carouselTrack');
  if (!track) return;

  track.scrollBy({
    left: direction * 210,
    behavior: 'smooth'
  });
}

function restartQuiz() {
  currentQ = 0;
  answers = new Array(QUESTIONS.length).fill(null);
  scores = {};
  renderQuestion(0);
  scrollQuizIntoView();
}

function toggleFaq(button) {
  const answer = button.nextElementSibling;
  const isOpen = button.classList.contains('open');

  document.querySelectorAll('.faq-q').forEach((btn) => {
    btn.classList.remove('open');
    btn.nextElementSibling.style.maxHeight = '0';
  });

  if (!isOpen) {
    button.classList.add('open');
    answer.style.maxHeight = `${answer.scrollHeight}px`;
  }
}

function launchConfetti() {
  const canvas = document.getElementById('confetti-canvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;

  const colors = ['#E8547A', '#B57BCC', '#F0B8CA', '#D8A8F0', '#FFD700', '#FF85A8', '#E8C0D8', '#FFFFFF'];
  const shapes = ['rect', 'circle', 'heart'];

  const particles = Array.from({ length: 120 }, () => ({
    x: Math.random() * canvas.width,
    y: Math.random() * -canvas.height,
    r: Math.random() * 7 + 3,
    color: colors[Math.floor(Math.random() * colors.length)],
    shape: shapes[Math.floor(Math.random() * shapes.length)],
    speed: Math.random() * 3 + 1.5,
    tilt: Math.random() * 10 - 5,
    rot: Math.random() * 360,
    rotS: Math.random() * 3 - 1.5
  }));

  let frame = 0;

  function drawHeart(context, size) {
    context.beginPath();
    context.moveTo(0, -size * 0.3);
    context.bezierCurveTo(size * 0.5, -size * 0.8, size, 0, 0, size * 0.6);
    context.bezierCurveTo(-size, 0, -(size * 0.5), -size * 0.8, 0, -size * 0.3);
    context.closePath();
    context.fill();
  }

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    particles.forEach((p) => {
      p.y += p.speed;
      p.x += Math.sin(frame / 20 + p.tilt) * 0.7;
      p.rot += p.rotS;

      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate((p.rot * Math.PI) / 180);
      ctx.fillStyle = p.color;

      if (p.shape === 'rect') {
        ctx.fillRect(-p.r / 2, -p.r / 2, p.r, p.r * 1.5);
      } else if (p.shape === 'circle') {
        ctx.beginPath();
        ctx.arc(0, 0, p.r / 2, 0, Math.PI * 2);
        ctx.fill();
      } else {
        drawHeart(ctx, p.r);
      }

      ctx.restore();
    });

    frame += 1;

    if (frame < 200) {
      requestAnimationFrame(draw);
    } else {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  }

  draw();
}


} catch(error){console.error(error);}